import {
  Activity,
  Bean,
  BookOpen,
  Boxes,
  Cherry,
  Container,
  Download,
  Droplet,
  Droplets,
  Eye,
  Fence,
  FlaskConical,
  Flame,
  Flower,
  Flower2,
  Gauge,
  Gift,
  GlassWater,
  LayoutGrid,
  Leaf,
  Library,
  LifeBuoy,
  Lightbulb,
  Network,
  Rows3,
  Ruler,
  Salad,
  ScanSearch,
  Scissors,
  Shrub,
  Smile,
  Sprout,
  Thermometer,
  Vegan,
  Waves,
  Wheat,
  Wind,
  Wrench,
  type LucideIcon,
} from 'lucide-react'

export interface IncludedFeature {
  label: string
  icon: LucideIcon
  /** Headline features get a larger, highlighted card */
  featured?: boolean
}

export const everythingIncluded: IncludedFeature[] = [
  { label: '6 Complete Volumes', icon: Library, featured: true },
  { label: 'Complete 6-in-1 Hydroponics System', icon: Boxes, featured: true },
  { label: '100% Visual Main System', icon: Eye, featured: true },
  { label: 'Beginner Friendly', icon: Smile, featured: true },
  { label: 'Hydroponic System Selection', icon: LayoutGrid },
  { label: 'NFT', icon: Rows3 },
  { label: 'DWC', icon: Container },
  { label: 'Kratky', icon: GlassWater },
  { label: 'Drip Hydroponics', icon: Droplet },
  { label: 'Reservoir Management', icon: Waves },
  { label: 'Nutrient Management', icon: FlaskConical },
  { label: 'pH', icon: Gauge },
  { label: 'EC', icon: Activity },
  { label: 'Water Management', icon: Droplets },
  { label: 'Germination', icon: Bean },
  { label: 'Seedlings', icon: Sprout },
  { label: 'Healthy Roots', icon: Network },
  { label: 'Plant Establishment', icon: Shrub },
  { label: 'Hydroponic Crop Guides', icon: BookOpen },
  { label: 'Leafy Greens', icon: Salad },
  { label: 'Herbs', icon: Leaf },
  { label: 'Tomatoes', icon: Cherry },
  { label: 'Peppers', icon: Flame },
  { label: 'Cucumbers', icon: Vegan },
  { label: 'Strawberries', icon: Flower2 },
  { label: 'Lighting', icon: Lightbulb },
  { label: 'Climate', icon: Thermometer },
  { label: 'Airflow', icon: Wind },
  { label: 'Spacing', icon: Ruler },
  { label: 'Plant Support', icon: Fence },
  { label: 'Pruning', icon: Scissors },
  { label: 'Pollination Awareness', icon: Flower },
  { label: 'Harvest Readiness', icon: Wheat },
  { label: 'Plant Problem Visuals', icon: ScanSearch },
  { label: 'Troubleshooting', icon: Wrench },
  { label: 'Recovery Processes', icon: LifeBuoy },
  { label: '5 Practical Grower Bonuses', icon: Gift },
  { label: 'Immediate Digital Access', icon: Download },
]
